import React, { useCallback, useEffect, useState } from "react";
import bottom3 from "../images/bottom3.svg";
import "./demoSection.css";
import { s3url } from "../utility/constand";

const initialCards = [
  {
    id: 1,
    title: "Security Beyond Fraud",
    description:
      "Embedded files and malware that prevent verification software",
    image: `${s3url}/9.svg`,
    bgcolor: "#293A6E",
  },
  {
    id: 2,
    title: "Text–Level Precision",
    description:
      "Unlike generic PDF validation tools, TamperProof highlights exact tampered words and edits.",
    image: `${s3url}/7.svg`,
    bgcolor: "#94C358",
  },
  {
    id: 3,
    title: "Advanced Signature Validation",
    description:
      "Using public/private key cryptography to detect unmatched PDF integrity verification.",
    image: `${s3url}/purplecard.svg`,
    bgcolor: "#8B58F5",
  },
];

const DemoSection = () => {
  const [step, setStep] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const handleScrollToViewPort = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => (prev + 1) % initialCards.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="demo-section">
      <div className="demo-section-content">
        <h1 className="demo-section-heading">
          Built to <span>Expose </span>
          What Others Overlook
        </h1>
        <p className="demo-section-text">
          Most tools stop at surface-level checks. TamperProof validates every
          layer from text to signatures to security.
        </p>
        <button
          className="book-demo"
          style={{
            fontSize: "1rem",
            color: "#6D2FEC",
            border: "1px solid #A0E100",
            backgroundImage:
              "radial-gradient(circle at 50% 50%, #DFFF8E, #AFF500 91%)",
          }}
          onClick={() => handleScrollToViewPort("book-a-demo")}
        >
          Book a Free Demo
        </button>
      </div>

      <div className="semi-circle-wrapper">
        <div className="polygon">
          <img src={`${s3url}/Polygon 1.svg`} alt="" />
        </div>

        <div className="semi-circle">
          {/* Lines always visible */}
          <div className="card-line-left"></div>
          <div className="card-line-middle"></div>
          <div className="card-line-right"></div>

          {!isMobile ? (
            // Desktop → 3 positions
            [0, 1, 2].map((pos) => (
              <div key={pos} className={`demo-card-stack position-${pos}`}>
                {initialCards.map((card, i) => {
                  const visibleIndex = (pos + step) % 3;
                  const isActive = i === visibleIndex;

                  return (
                    <div
                      key={card.id}
                      className={`demo-card position ${
                        isActive ? "demoactive" : "demohidden"
                      }`}
                      style={{
                        backgroundImage: `url(${card.image})`,
                        backgroundColor: card.bgcolor,
                      }}
                    ></div>
                  );
                })}
              </div>
            ))
          ) : (
            // Mobile → only 1 card centered, but keep lines
            <div className="demo-card-stack mobile-center">
              <div
                className="demo-card demoactive"
                style={{
                  backgroundImage: `url(${initialCards[step].image})`,
                  backgroundColor: initialCards[step].bgcolor,
                }}
              ></div>
            </div>
          )}
        </div>
      </div>
      <img src={bottom3} alt="bottom_3" className="bounce-bottom-2" />
    </div>
  );
};

export default DemoSection;
